<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12">
        <v-card class="sup-card" flat>
          <!-- HEADER BAND -->
          <div class="sup-header pl-base-bg">
            <div class="sup-header-icon">
              <v-icon color="#fff" size="22">mdi-lifebuoy</v-icon>
            </div>
            <div>
              <div class="sup-title">Support</div>
              <div class="sup-subtitle">We're here to help you</div>
            </div>
          </div>

          <div class="pa-6">
            <!-- CONTACT OPTIONS -->
            <div class="sup-section-label">Contact Us</div>
            <v-row class="mb-6" dense align="stretch">
              <!-- CALL -->
              <v-col cols="12" md="4" class="d-flex">
                <v-card class="pa-4 text-center support-card support-card--call d-flex flex-column flex-grow-1" flat>
                  <v-icon size="30" color="#fff">mdi-phone</v-icon>
                  <h3 class="mt-2 white--text">Call Us</h3>

                  <p class="sup-contact-line mb-1">+91 7483798592</p>
                  <p class="sup-contact-line">+91 7990198868</p>

                  <v-spacer />

                  <div class="mt-2">
                    <v-btn
                      small
                      class="sup-glass-btn mr-2"
                      @click="callNow('+917483798592')"
                    >
                      Call 1
                    </v-btn>

                    <v-btn
                      small
                      class="sup-glass-btn"
                      @click="callNow('+917990198868')"
                    >
                      Call 2
                    </v-btn>
                  </div>
                </v-card>
              </v-col>

              <!-- EMAIL -->
              <v-col cols="12" md="4" class="d-flex">
                <v-card class="pa-4 text-center support-card support-card--email d-flex flex-column flex-grow-1" flat>
                  <v-icon size="30" color="#fff">mdi-email</v-icon>
                  <h3 class="mt-2 white--text">Email</h3>
                  <p class="sup-contact-line">profitledgex@gmail.com</p>

                  <v-spacer />

                  <div class="mt-2">
                    <v-btn small class="sup-glass-btn" @click="sendEmail">
                      Send Email
                    </v-btn>
                  </div>
                </v-card>
              </v-col>

              <!-- WHATSAPP -->
              <v-col cols="12" md="4" class="d-flex">
                <v-card class="pa-4 text-center support-card support-card--whatsapp d-flex flex-column flex-grow-1" flat>
                  <v-icon size="30" color="#fff">mdi-whatsapp</v-icon>
                  <h3 class="mt-2 white--text">WhatsApp</h3>
                  <p class="sup-contact-line">Chat with our team instantly</p>

                  <v-spacer />

                  <div class="mt-2">
                    <v-btn
                      small
                      class="sup-glass-btn mr-2"
                      @click="openWhatsApp('917483798592')"
                    >
                      Chat 1
                    </v-btn>

                    <v-btn
                      small
                      class="sup-glass-btn"
                      @click="openWhatsApp('917990198868')"
                    >
                      Chat 2
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- SUPPORT FORM -->
            <div class="sup-section-label">Raise a Ticket</div>
            <v-form ref="form">
              <div class="sup-panel mb-6">
                <v-text-field
                  v-model="form.name"
                  label="Your Name"
                  :rules="[rules.required]"
                  dense
                  outlined
                  prepend-inner-icon="mdi-account"
                />

                <v-text-field
                  v-model="form.phone"
                  label="Phone Number"
                  :rules="[rules.required]"
                  dense
                  outlined
                  type="tel"
                  prepend-inner-icon="mdi-phone"
                />

                <v-select
                  v-model="form.issueType"
                  :items="issueTypes"
                  label="Issue Type"
                  :rules="[rules.required]"
                  dense
                  outlined
                  prepend-inner-icon="mdi-format-list-bulleted"
                />

                <v-textarea
                  v-model="form.message"
                  label="Describe your issue"
                  :rules="[rules.required]"
                  rows="3"
                  dense
                  outlined
                  prepend-inner-icon="mdi-message-text"
                />

                <v-row justify="end" no-gutters>
                  <v-btn class="sup-save-btn" @click="submitTicket">
                    Submit Request
                  </v-btn>
                </v-row>
              </div>
            </v-form>

            <!-- FAQ -->
            <div class="sup-section-label">Frequently Asked Questions</div>
            <div class="sup-panel">
              <v-expansion-panels flat>
                <v-expansion-panel v-for="(faq, index) in faqs" :key="index" class="sup-faq-panel">
                  <v-expansion-panel-header>
                    {{ faq.q }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ faq.a }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SupportPage",

  data() {
    return {
      rules: {
        required: (v) => !!v || "This field is required",
      },
      form: {
        name: "",
        phone: "",
        issueType: "",
        message: "",
      },

      issueTypes: [
        "Technical Issue",
        "Billing Issue",
        "Feature Request",
        "Bug Report",
      ],

      faqs: [
        {
          q: "How do I create an invoice?",
          a: "Go to the Invoices section, click the '+' button, fill in the details, and download your PDF.",
        },
        {
          q: "How do I add products?",
          a: "Go to the Products section and click '+'. Fill in the details and save.",
        },
        {
          q: "Is my data secure?",
          a: "Yes, your data is securely stored and protected.",
        },
      ],
    };
  },

  methods: {
    callNow(number) {
      window.location.href = `tel:${number}`;
    },

    sendEmail() {
      window.location.href = "mailto:profitledgex@gmail.com";
    },

    openWhatsApp(number) {
      window.open(`https://wa.me/${number}`, "_blank");
    },

    async submitTicket() {
      const isValid = this.$refs.form.validate();

      if (!isValid) return;

      try {
        await this.$store.dispatch("ticket/createTicket", this.form);
        this.$toast.success("Support request submitted!");
        this.$refs.form.reset();
      } catch (error) {
        this.$toast.error("Failed to submit request");
      }
    },
  },
};
</script>

<style scoped>
.sup-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

.sup-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
}

.sup-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sup-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.sup-subtitle {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

.sup-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 10px;
}

/* ================= CONTACT CARDS ================= */
.support-card {
  border-radius: 0;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  color: #fff;
  box-shadow: 0 6px 16px rgba(15, 30, 50, 0.12);
}

.support-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(15, 30, 50, 0.18);
}

.support-card--call {
  background: linear-gradient(135deg, #052f5e 0%, #0a5a90 100%);
}
.support-card--email {
  background: linear-gradient(135deg, #0a5a90 0%, #0d8478 100%);
}
.support-card--whatsapp {
  background: linear-gradient(135deg, #0d8478 0%, #15a355 100%);
}

.sup-contact-line {
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 2px;
}

.sup-glass-btn {
  background: rgba(255, 255, 255, 0.18) !important;
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.35);
  text-transform: none !important;
  box-shadow: none !important;
}

.sup-glass-btn:hover {
  background: rgba(255, 255, 255, 0.28) !important;
}

/* ================= PANELS ================= */
.sup-panel {
  background: #f8fafc;
  border: 1px solid #eef1f5;
  border-radius: 0;
  padding: 20px;
}

.sup-faq-panel {
  background: transparent !important;
  border-bottom: 1px solid #eef1f5;
}

.sup-faq-panel:last-child {
  border-bottom: none;
}

.sup-save-btn {
  background: var(--pl-base-bg-gradient) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
}
</style>
